export function Fetch(method, url, body) {
    this.method = method;
    this.url = url;
    this.body = body;
}

Fetch.prototype.fetch = function () {
    //console.log("url", this.url);
    //console.log("method", this.method);
    //console.log("body", this.body);
    let request = {
        method: this.method,
        // mode: 'no-cors',
        headers: {
            'Accept': 'application/json',
            "Content-Type": "application/json"
        }
    };
    if (this.method.toUpperCase() == "POST"
        || this.method.toUpperCase() == "PUT"
        || this.method.toUpperCase() == "DELETE")
        request.body = JSON.stringify(this.body);
    return fetch(this.url, request)
        .then(response => {
            //  console.log("response", response);
            let contentType = response.headers.get("content-type");
            if (contentType && contentType.includes("application/json") && response.status == 200) {
                return response.json();
            } else if (contentType && contentType.includes("application/json") && response.status == 404) {
                return response.json();
            } else if (response.status == 200) {
                return response;
            } else {
                return new Promise(function (resolve, reject) {
                    reject(Error("Greška u komunikaciji!"));
                });
            }
        })
};





